import { useEffect } from 'react';
import { reduxFields } from '../constants/formFields';
import { paymentMethodTypes } from '../constants/paymentMethods';

const { SELECTED_PAYMENT_METHOD, SELECTED_PAYMENT_METHOD_CODE, SELECTED_PAYMENT_METHOD_TYPE } =
  reduxFields;
const { PAY_INTERNAL } = paymentMethodTypes;

const useInternalPayment = (
  paymentMethods = [],
  selectedPaymentMethodCode,
  change,
  clearFields,
) => {
  useEffect(() => {
    const isPayInternalSelectedButNotAvailable =
      selectedPaymentMethodCode === PAY_INTERNAL &&
      !paymentMethods.some(({ code }) => code === PAY_INTERNAL);

    if (paymentMethods.length === 1) {
      const [defaultMethod] = paymentMethods;

      change(SELECTED_PAYMENT_METHOD, {
        code: defaultMethod.code,
        type: defaultMethod.type,
      });
      change(SELECTED_PAYMENT_METHOD_TYPE, defaultMethod.type);
      change(SELECTED_PAYMENT_METHOD_CODE, defaultMethod.code);
    } else if (isPayInternalSelectedButNotAvailable) {
      clearFields(
        false,
        false,
        SELECTED_PAYMENT_METHOD,
        SELECTED_PAYMENT_METHOD_TYPE,
        SELECTED_PAYMENT_METHOD_CODE,
      );
    }
  }, [change, clearFields, paymentMethods, selectedPaymentMethodCode]);
};

export default useInternalPayment;
